import "~/scss/page-templates/about.scss";

import gsap from "gsap";
import { enableScrollingForOverlay, disableScrollingForOverlay } from "~/js/components/overlay/helper";

console.log('about.ts');

let bioExpandedEl:HTMLElement|null = null;
let bioExpandedContentContainerEl:HTMLElement|null = null;
let bioExpandedContentEl:HTMLElement|null = null;
let bioExpandedCloseBtnEl:HTMLElement|null = null;
let bioExpandedBgEl:HTMLElement|null = null;

let bioExpandedOpenTL:GSAPTimeline = gsap.timeline({
  paused: true,
  onStart: () => {
    if( bioExpandedEl ) {
      bioExpandedEl.classList.add('visible');
    }
  }
})

let bioExpandedCloseTL:GSAPTimeline = gsap.timeline({
  paused: true,
  onComplete: () => {
    if( bioExpandedEl ) {
      bioExpandedEl.classList.remove('visible');
    }
  }
})

function initBio() {
  console.log("initBio()");

  bioExpandedEl = document.querySelector(".about__bio-expanded");

  if( bioExpandedEl ) {
    bioExpandedContentContainerEl = bioExpandedEl?.querySelector(".about__bio-expanded__content-container");
    bioExpandedContentEl = bioExpandedEl?.querySelector(".about__bio-expanded__content");
    bioExpandedCloseBtnEl = bioExpandedEl?.querySelector(".about__bio-expanded__close-btn");
    bioExpandedBgEl = bioExpandedEl?.querySelector(".about__bio-expanded__bg");
    bioExpandedCloseBtnEl = bioExpandedEl?.querySelector(".about__bio-expanded__close-btn");


    bioExpandedOpenTL.set(bioExpandedEl, {autoAlpha:1});
    bioExpandedOpenTL.fromTo(bioExpandedBgEl, {autoAlpha:0}, {autoAlpha:1, duration:0.3});
    bioExpandedOpenTL.fromTo(bioExpandedContentContainerEl, {autoAlpha:0}, {autoAlpha:1, duration:0.3}, '-=0.2');

    bioExpandedCloseTL.to(bioExpandedContentContainerEl, {autoAlpha:0, duration:0.3});
    bioExpandedCloseTL.to(bioExpandedBgEl, {autoAlpha:0, duration:0.3}, '-=0.2');
  }


  let bioBtns = document.querySelectorAll(".about__leadership__bio-btn");
  console.log(bioBtns);
  for( let i=0; i<bioBtns.length; i++ ) {
    bioBtns[i].addEventListener("click", (e) => {
      let index = bioBtns[i].getAttribute('data-index');
      showBio(index);
    })
  }

  
  console.log(bioExpandedCloseBtnEl);
  if( bioExpandedCloseBtnEl ) {
    bioExpandedCloseBtnEl.addEventListener("click", () => {
      hideBio();
    })
  }


}

function showBio(index:any) {
  console.log("showBio()", index);
  if( window.leadershipData && window.leadershipData[index] ) {
    if( bioExpandedContentEl ) {
      bioExpandedContentEl.innerHTML = window.leadershipData[index].bio;

      // bioExpandedEl.classList.add('visible');
      if( bioExpandedCloseTL ) {
        bioExpandedCloseTL.pause();
      }
      bioExpandedOpenTL.restart();

      disableScrollingForOverlay();
    }
    
  }
}

function hideBio() {
  console.log("hideBio()");

  if( bioExpandedEl ) {
    // bioExpandedEl.classList.remove('visible');

    if( bioExpandedOpenTL ) {
      bioExpandedOpenTL.pause();
    }

    bioExpandedCloseTL.restart();

    enableScrollingForOverlay();
  }
}


document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    initBio();
  }, 100);
  
});